const useXCountStepper = ({ value, min, max, onChange }) => {
  const canDecrement = value > min;
  const canIncrement = value < max;

  const decrement = () => onChange({ value: Math.max(value - 1, min) });
  const increment = () => onChange({ value: Math.min(value + 1, max) });

  return { canDecrement, canIncrement, decrement, increment };
};

export default useXCountStepper;
